import Vue                                      from 'vue'
import Router                                   from 'vue-router'
import axios                                    from 'axios'
import VueAxios                                 from 'vue-axios'

// import Coins                                    from '../views/View_Coins'
import Coin                                     from '../views/View_Coin'
import Account                                  from '../views/View_Account'
import Stats                                    from '../views/View_Stats'
import Referral                                 from '../views/View_Referral'
import DownloadMiner                            from '../views/View_Download_Miner'
import Support                                  from '../views/View_Support'
import Wizard                                   from '../views/View_Wizard'
import Monitoring                               from '../views/View_Monitoring_App'

import store from '../store'

import VueSocketIOExt from 'vue-socket.io-extended';
import { io } from 'socket.io-client';

const socket = io('wss://ws.unminable.com', {
  path: '/',
  transports: [
    'websocket'
  ]
});

Vue.use(VueSocketIOExt, socket, {store});
Vue.use(Router)
Vue.use(VueAxios, axios)

Vue.axios.defaults.baseURL = process.env.API_URL

const router = new Router({
  mode: 'history',
  routes: [
    {
      path      : '/coins',
      redirect  : '/'
    },
    {
      path      : '/coins/:symbol',
      redirect  : to => {
        return { path: '/', query: { coin: to.params.symbol } }
      }
    },
    {
      path: '/',
      props: true,
      name: 'coin',
      component: Coin
    },
    {
      path: '/account',
      props: true,
      name: 'account',
      component: Account
    },
    {
      path: '/coins/:symbol/address/:addressqs?/:tab?',
      redirect: to => {
        return { path: '/address/:addressqs?', query: { coin: to.params.symbol, tab: to.params.tab } }
      }
    },
    {
      path      : '/address/:addressqs?',
      props     : true,
      name      : 'stats',
      component : Stats
    },
    {
      path      : '/referrals',
      name      : 'referral',
      component : Referral
    },
    {
      path      : '/miner',
      name      : 'download-miner',
      component : DownloadMiner
    },
    {
      path      : '/start',
      name      : 'download-miner-start',
      component : DownloadMiner
      // redirect: '/wizard'
    },
    {
      path      : '/support/:type?/:slug?',
      name      : 'support',
      component : Support
    },
    {
      path      : '/wizard',
      name      : 'wizard',
      component : Wizard
    },
    {
      path      : '/app',
      name      : 'app',
      component : Monitoring
    },
    // and finally the default route, when none of the above matches:
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.name === 'coin' && from.name === 'coin') {
      return null
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  if (to.query.coin && to.query.coin !== store.getters.coin) {
    store.dispatch('setCoin', { coin: to.query.coin }).then(() => {
      // store.dispatch('addToCoinList', to.query.coin)
      next();
    }).catch((err) => {
      if (err.message === 'INVALID') next('/')
    })
  } else next();
})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js